export default __webpack_public_path__ + "static/media/page_layout.f77acd25.svg";